let resizeTimer;
const init = () => {
	const { body } = document;
	const BLOCK_ANIMATION = 'stop-animation';

	body.classList.add( BLOCK_ANIMATION );

	clearTimeout( resizeTimer );
	resizeTimer = setTimeout( () => {
		body.classList.remove( BLOCK_ANIMATION );
	}, 400 );
};

export default init;
